const { globalStorage: storage } = window.o_global ?? {};
export {
  storage
};
